export default __webpack_public_path__ + "static/profile-logo-eggplant-6ebb3c0ff6d7712933d66a1ec0f535df.svg";